module.exports = "https://static.wmbcdn.com/uniweb/images/45c8aaefca01ad4775f7c187ae47a9c6.svg";